<template>
  <div class="play-button">
    <transition name="fade" mode="out-in">
      <template v-if="isLoading">
        <v-loader white />
      </template>
      <template v-else>
        <v-icon icon="play_arrow" size="2.75rem" />
      </template>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    isPlaying: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.play-button {
  // Hardcoded white & black to prevent --dark-mode overrides
  color: white;
  background: rgba(black, 0.56);
  height: $size--10;
  width: $size--10;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }
}
</style>
